import { render, staticRenderFns } from "./NewLogin.vue?vue&type=template&id=a8fc48d2"
import script from "./NewLogin.vue?vue&type=script&lang=js"
export * from "./NewLogin.vue?vue&type=script&lang=js"
import style0 from "./NewLogin.vue?vue&type=style&index=0&id=a8fc48d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports